import axios from "../../../../utils/axiosInceptor";
import * as action_types from "./constants";
import { maintenanceService, portalService } from "../../../../configs/constants";
import { api } from "../../../../services/api";
import { message } from "antd";
const getShiftsUrl = `${portalService}/roaster/getProvider`;  // used
const deleteShiftUrl = `${maintenanceService}/maintenance/removeShift`;
const createShiftUrl = `${maintenanceService}/create-shift`;  // used
const holidaysUrl = `${maintenanceService}/holiday`;  // used

const assignShiftUrl = `${maintenanceService}/maintenance/assignShiftToSP`;
const editShiftUrl = `${maintenanceService}/maintenance/updateShift`;
const operatingHours = `${maintenanceService}/maintenance/getSPShifts`;

export const getOperatingHours = () => {
  return async (dispatch) => {
    try {
      const {
        data: { result },
      } = await axios.get(`${operatingHours}`);
      dispatch({
        type: action_types.GET_OPERATING_HOURS,
        data: result,
      });
    } catch (e) {
      console.log("Err", e);
    }
  };
};

export const getAllShifts = (body) => {
  return async (dispatch) => {
    const url = `${getShiftsUrl}/${body.selectedProvider}/${body.selectedCenter}`;
    try {
      const result = await axios.post(url);
      dispatch({
        type: action_types.GET_SHIFTS_LIST,
        data: result?.data,
      });
    } catch (e) {
      console.log("Err", e);
      message.error(e?.response?.data?.message);
      throw e;
    }
  };
};

export const getEmptyShifts = () => {
  return async (dispatch) => {
    dispatch({
      type: action_types.GET_SHIFTS_LIST,
      data: { shifts: [], config: null },
    });
  };
};


export const deleteShifts = async (item) => {
  const url = `${deleteShiftUrl}`;
  try {
    const {
      data: { result },
    } = await axios.patch(url,
      {
        "id": item._id,
        "sureDelete": true
      });

    return result
  } catch (e) {
    console.log("Err", e);
  }
};

export const addShift = async (payload, companyCode) => {

  const url = createShiftUrl

  try {

    const {
      data: { result },
    } = await axios.post(url, payload, { headers: { 'company-code': companyCode } });

    return result

  } catch (e) {
    console.log("Err", e);
  }
};


export const assignShiftData = (payload:object) => {
  return async (dispatch) => {
    dispatch({
      type: action_types.GET_SHIFTS_LIST,
      data: payload,
    });
  };
};

export const assignDefault = async (payload) => {

  const url = assignShiftUrl

  try {

    const {
      data: { result },
    } = await axios.post(url, payload);

    return result

  } catch (e) {
    console.log("Err", e);
  }
};

export const editShift = async (payload, companyCode) => {

  const url = editShiftUrl

  try {

    const {
      data: { result },
    } = await axios.patch(url, payload);

    return result

  } catch (e) {
    console.log("Err", e);
  }
};

export const setSelectedCompany = (companyCode) => {
  window.localStorage.setItem('Selected-Company-Code', companyCode);
  return (dispatch) => {
    dispatch({
      type: action_types.SELECT_COMPANY,
      data: companyCode,
    });
  }
};

export const fetchProviders = (companyCode) => {
  try {

    return async (dispatch) => {
      const response = await api.getProviderByCompanyCode(companyCode);
      dispatch({
        type: action_types.FETCH_PROVIDERS_SUCCESS,
        data: response,
      });

    }
  } catch (error) {
    console.error("Failed to fetch providers", error);
  }
};

export const fetchEmptyProviders = () => {
  return async (dispatch) => {
    dispatch({
      type: action_types.SET_PROVIDERS,
      data: null,
    });
    dispatch({
      type: action_types.FETCH_PROVIDERS_SUCCESS,
      data: [],
    });
  }
};

export const fetchEmptyCenters = () => {
  return async (dispatch) => {
    dispatch({
      type: action_types.SET_CENTER,
      data: null,
    });
    dispatch({
      type: action_types.FETCH_CENTERS_SUCCESS,
      data: [],
    });
  }
};

export const fetchCenters = (companyCode, category) => {
  try {
    console.log('fecth center', companyCode, category.value);
    return async (dispatch) => {
      const response = await api.getCenterByCompanyCode(companyCode, category.value);

      dispatch({
        type: action_types.FETCH_CENTERS_SUCCESS,
        data: response,
      });

    }
  } catch (error) {
    console.error("Failed to fetch centers", error);
  }
};

export const setSelectedProvider = (providerValue) => {
  return (dispatch) => {
    dispatch({
      type: action_types.SET_PROVIDERS,
      data: providerValue.value,
    });
  }
};

export const setSelectedCenter = (value) => {
  return (dispatch) => {
    dispatch({
      type: action_types.SET_CENTER,
      data: value.value,
    });
  }
};

export const resetCenters = () => ({
  type: action_types.RESET_CENTERS,
});


export const addHolidays = async (payload) => {

  const url = holidaysUrl;
  try {
    const {
      data: { result },
    } = await axios.post(url, payload);
    return result
  } catch (e) {
    console.log("Err", e);
  }
};

export const getHolidays = (payload) => {

  return async (dispatch) => {
    try {
      const url = `${holidaysUrl}/${payload.provider}${payload.range?.length > 0 && `?fromDate=${payload?.range[0]}&toDate=${payload?.range[1]}`}`;
      const result = await axios.get(url, payload);

      dispatch({
        type: action_types.GET_HOLIDAYS,
        data: result?.data,
      });

    } catch (error) {
      console.error("Failed to fetch holidays", error);
      throw error;
    }
  }

};


